import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { InboxFilter } from '../../../../sic-lib/types/InboxTypes';
import NewRecentDirectionButtons from '../../NewRecentDirectionButtons/NewRecentDirectionButtons';
import NewRecentFilterOptionsSearchInput from '../NewRecentFilterOptionsSearchInput/NewRecentFilterOptionsSearchInput';

export default function NewRecentFilterOptionsSearchBar({ compState, setCompState }: Props) {
    const { classes } = useStyles();

    return (
        <Paper elevation={0} variant="outlined" className={classes.root}>
            <Grid
                container
                direction="row"
                alignItems="center"
                spacing={1}
                className={classes.gridContainer}
            >
                <Grid item className={classes.directionBtns}>
                    <NewRecentDirectionButtons compState={compState} setCompState={setCompState} />
                </Grid>
                <Grid item>
                    <Divider
                        orientation="vertical"
                        light={true}
                        flexItem={true}
                        style={{ height: 44 }}
                    />
                </Grid>
                <Grid item className={classes.searchField}>
                    <NewRecentFilterOptionsSearchInput
                        compState={compState}
                        setCompState={setCompState}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
}

interface Props {
    compState: InboxFilter;
    setCompState: React.Dispatch<Partial<InboxFilter>>;
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        // width: `calc(100% - ${theme.spacing(0.75)})`,
        width: '98%',
        margin: 'auto',
        paddingTop: theme.spacing(0.75),
        paddingBottom: theme.spacing(0.6),
        marginTop: theme.spacing(0.75),
        marginBottom: theme.spacing(0.75),
    },
    gridContainer: {
        marginLeft: 0,
        maxWidth: '100%',
    },
    directionBtns: {
        flex: 1,
        flexGrow: 0,
    },
    searchField: {
        flex: 5,
    },
}));
